import 'babel-polyfill'
import $ from 'jquery';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/modal'
import {mailProtect} from './modules/mailprotect';
import {createMenu, initHoverFunctionality, initMobileMenuFunctionality} from './modules/navigation-controller';
import {createSlider, createSliderHeader} from './modules/swiper';
import {filters} from './modules/filters';
import {media2click} from './modules/media2click';
import {removeNbspPTag} from './modules/removeemptyp';

$(document).ready(function () {

    const updateSwiperPausePlayLabels = (button) => {
        const isPlaying = button.classList.contains('playing');
        const label = isPlaying ? 'Slider pausieren' : 'Slider starten';

        button.setAttribute('title', label);
        button.setAttribute('aria-label', label);
    };

    const focusActiveSlideLink = (swiper, position = 'first') => {
        const activeSlide = swiper.slides[swiper.activeIndex];
        if (!activeSlide) {
            return;
        }

        const activeLinks = Array.from(activeSlide.querySelectorAll('a[href], area[href]'))
            .filter((element) => element.getAttribute('tabindex') !== '-1');

        if (activeLinks.length === 0) {
            return;
        }

        const targetLink = position === 'last'
            ? activeLinks[activeLinks.length - 1]
            : activeLinks[0];

        targetLink.focus();
    };

    mailProtect();
    filters();
    media2click();
    createMenu('#dropdown-toggle-mobile', 'mobile-menu-active');
    initHoverFunctionality();
    initMobileMenuFunctionality();
    removeNbspPTag();

    //select all slides on the current page
    let $allSlidesHeader = $('.ba-carousel-header .swiper-slide');
    if ($allSlidesHeader.length > 1) {
        //slider only needs to be created,
        // if there are at least two slides on the page
        $('.ba-carousel-header').each(function () {
            //check how many slides are on the current carousel-element
            let $this = $(this);
            if ($this.find($allSlidesHeader).length > 1) {
                createSliderHeader($this);
            }
        });
        // Swiper play-pause function
        const swiperControls = document.querySelector('.swiper-controls');
        swiperControls.classList.remove('d-none')
        const initializedSwiper = document.querySelector('.swiper-container').swiper;
        const swiperButtonPrev = document.querySelector('.swiper-button-prev');
        const swiperButtonPausePlay = document.querySelector('.swiper-button-pause-play');
        const swiperButtonNext = document.querySelector('.swiper-button-next');
        let pendingSlideLinkFocus = null;

        initializedSwiper.on('slideChangeTransitionEnd', () => {
            if (!pendingSlideLinkFocus) {
                return;
            }

            focusActiveSlideLink(initializedSwiper, pendingSlideLinkFocus);
            pendingSlideLinkFocus = null;
        });

        swiperButtonPrev.addEventListener('click', () => {
            pendingSlideLinkFocus = 'last';
        });
        updateSwiperPausePlayLabels(swiperButtonPausePlay);
        swiperButtonPausePlay.addEventListener('click', () => {
            if (swiperButtonPausePlay.classList.contains('playing')) {
                initializedSwiper.autoplay.stop();
                swiperButtonPausePlay.classList.remove('playing');
            } else {
                initializedSwiper.autoplay.start();
                swiperButtonPausePlay.classList.add('playing');
            }
            updateSwiperPausePlayLabels(swiperButtonPausePlay);
        });
        swiperButtonNext.addEventListener('click', () => {
            pendingSlideLinkFocus = 'first';
        });
    }

    let $allSlidesContent = $('.ba-carousel .swiper-slide');
    if ($allSlidesContent.length > 1) {
        $('.ba-carousel').each(function () {
            //check how many slides are on the current carousel-element
            let $this = $(this);
            if ($this.find($allSlidesContent).length > 1) {
                createSlider($this);
            }
        });
    }


    $('.main-container-access').focus(function () {
        let $focusElement = $(this);
        $([document.documentElement, document.body]).animate({
            scrollTop: $($focusElement.attr('href')).offset().top
        }, 100);
    });
    if ($('.table').length > 0) {
        $('.table').parent().addClass('responsive-table');
        if ($('.rotate-text').closest('td').length > 0) {
            $('.rotate-text').closest('td').addClass('rotated-text');
        }
        if ($('.rotate-text').closest('th').length > 0) {
            $('.rotate-text').closest('th').addClass('rotated-text');
        }
    }

    $('.read-more-content').addClass('hide');
    if ($('.read-more-show').length > 0) {
        $('.read-more-show').prev().addClass('acc-inline-btn');
        $('.read-more-hide').prev().addClass('acc-inline-btn');
    }
    // Set up the toggle effect:
    $('.read-more-show').on('click', function (e) {
        $(this).next('.read-more-content').removeClass('hide');
        $(this).addClass('hide');
        $(this).attr('aria-expanded', 'true');
        $(this).next('.read-more-content').children('.read-more-hide').removeClass('hide').attr('aria-expanded', 'true');
        $('.read-more-show').prev().removeClass('acc-inline-btn');
        $('.read-more-hide').prev().addClass('acc-inline-btn');
        e.preventDefault();
    });

    $('.read-more-hide').on('click', function (e) {
        var content = $(this).parent('.read-more-content');
        content.addClass('hide');
        $(this).attr('aria-expanded', 'false');
        content.prev('.read-more-show').removeClass('hide').attr('aria-expanded', 'false'); // Hide only the preceding 'Read More'
        $('.read-more-show').prev().addClass('acc-inline-btn');
        $('.read-more-hide').prev().removeClass('acc-inline-btn');
        e.preventDefault();
    });

    let objSearchForm = $('#indexedsearch');
    let objSearchBoxIcon = $('#search-box-icon');
    if (objSearchBoxIcon.length >= 1) {
        objSearchBoxIcon.on('click', function (){
            objSearchForm.submit();
        });
    }
});
